import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GuidSelectModel } from "services/api/cplapi/CPLAPI";
import { IServiceChargeInvoicingService } from "services/ServiceChargeInvoicingService";
import { RootState } from "setup";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

type ServiceChargeInvoicingProps = {
  LoadingServiceChargeDateCodes: boolean;
  ServiceChargeDateCodes: GuidSelectModel[];
};

const initialState: ServiceChargeInvoicingProps = {
  LoadingServiceChargeDateCodes: false,
  ServiceChargeDateCodes: new Array<GuidSelectModel>(),
};

export const serviceChargeDateCodesSlice = createSlice({
  name: "serviceChargeDateCodes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getServiceChargeDateCodes.pending, (state) => {
        state.LoadingServiceChargeDateCodes = true;
      })
      .addCase(getServiceChargeDateCodes.rejected, (state) => {
        state.LoadingServiceChargeDateCodes = false;
      })
      .addCase(getServiceChargeDateCodes.fulfilled, (state, action) => {
        state.LoadingServiceChargeDateCodes = false;
        state.ServiceChargeDateCodes = action.payload;
      });
  },
});

export const getServiceChargeDateCodes = createAsyncThunk(
  "serviceChargeDateCodes/getServiceChargeDateCodes",
  async () => {
    const serviceChargeInvoicingService = container.get<IServiceChargeInvoicingService>(
      SERVICE_TYPES.ServiceChargeInvoicingService
    );
    return await serviceChargeInvoicingService.getServiceChargeDateCodes();
  }
);

export const selectLoadingServiceChargeDateCodes = (state: RootState) =>
  state.serviceChargeDateCodes.LoadingServiceChargeDateCodes;
export const selectServiceChargeDateCodes = (state: RootState) => state.serviceChargeDateCodes.ServiceChargeDateCodes;

export default serviceChargeDateCodesSlice.reducer;
